const headlineTextRenderData = [ 
  {
    areaId: 'header',
    pluginId: "93ba4031-e603-11ec-bcab-7173ff18dcae",
    version: "0.*",
    initialPluginState: {
      __ststrK: 0,
      content: "<h1>Headline Example</h1>",
      style: {
        customCss: "",
        cssUrl: "",
      },
    },
  },
  {
    areaId:'body',
    pluginId: "93ba4031-e603-11ec-bcab-7173ff18dcae",
    version: "0.*",
    initialPluginState: {
      __ststrK: 0,
      content: "<p>Single-page layouts put all of the primary content for a site on a single web page. Navigation is done through scrolling, often with shortcuts to jump to particular sections and sometimes with parallax scrolling effects. Occasionally, they may use secondary pages for terms and conditions, privacy policies, or other information.</p>",
      style: {
        customCss: "",
        cssUrl: "",
      },
    },
  }, 
];

const twoColumnsTextOnlyRenderData = [{  
  areaId: 'td1',
  pluginId: "93ba4031-e603-11ec-bcab-7173ff18dcae",
  version: "0.*",
  initialPluginState: {
    __ststrK: 0,
    content: "<p>I am one. Single-page layouts put all of the primary content for a site on a single web page. Navigation is done through scrolling, often with shortcuts to jump to particular sections and sometimes with parallax scrolling effects. Occasionally, they may use secondary pages for terms and conditions, privacy policies, or other information.</p>",
    style: {
      customCss: "",
      cssUrl: "",
    },
  },
},
{
  areaId:'td2',
  pluginId: "93ba4031-e603-11ec-bcab-7173ff18dcae",
  version: "0.*",
  initialPluginState: {
    __ststrK: 0,
    content: "<p>I am two. Single-page layouts put all of the primary content for a site on a single web page. Navigation is done through scrolling, often with shortcuts to jump to particular sections and sometimes with parallax scrolling effects. Occasionally, they may use secondary pages for terms and conditions, privacy policies, or other information.</p>",
    style: {
      customCss: "",
      cssUrl: "",
    },
  },
},
];

const headlineTextTemplateLayout = {
  node: 'section',
  areaId: 'section',
  ariaAttrs:[],
  classList:[],
  layoutDisplay:'grid',
  layoutStyles:[
    {attr:'display', value:'grid'}, 
    {attr:'grid-template-columns', value:'repeat(8, 1fr)'},
    {attr:'height', value:'auto!important'},
    {attr:'margin', value:'auto'},
  ],
  maxWidth: '682px',
  areas:[
    {
      node:'div',
      areaId:'header',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[{attr:'grid-column', value:'span 8'}],
      areas:[],
    },
    {
      node:'div',
      areaId:'body',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[{attr:'grid-column', value:'span 8'}],
      areas:[],
    },
  ],
};

const headlineTextTemplateStylingData = {
  section:[],
  header:[],
  body:[],
};

const twoColumnsTextOnlyLayout = {
  node: 'section',
  areaId: 'section',
  ariaAttrs:[],
  classList:[],
  layoutDisplay:'grid',
  layoutStyles:[
    {attr:'display', value:'grid'}, 
    {attr:'gap', value:'1rem'}, 
    {attr:'grid-template-columns', value:'repeat(8, 1fr)'}, 
    {attr:'height', value:'auto!important'},
    {attr:'margin', value:'auto'},
  ],
  maxWidth: '682px',
  areas:[
    {
      node:'div',
      areaId:'td1',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-column', value:'span 4'},
      ],
      areas:[],
    },
    {
      node:'div',
      areaId:'td2',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-column', value:'span 4'},
      ],
      areas:[],
    },
  ],
};

const twoColumnsTextOnlyStylingData = {
  section:[],
  td1:[],
  td2:[],
};

export const headlineTextTemplate = {
  id: "textTemplate1",
  type: "section",
  pluginId: "b8e2bb81-e603-11ec-9344-a7f4dfb24b7b",
  name: 'Text with Headline',
  description: 'Text with Headline',
  config: {
    templateLayoutData: headlineTextTemplateLayout,//json config
    templateStylingData: headlineTextTemplateStylingData,//json config
    templateRenderData: headlineTextRenderData,//json config    
  },
  category: ["all", "text"],
  thumbnail: "/img.png",
  metadata: {},
};

export const twoColumnsTextOnly = {
  id: "textTemplate2",
  type: "section",
  pluginId: "b8e2bb81-e603-11ec-9344-a7f4dfb24b7b",
  name: 'Text in 2 columns',
  description: 'Text in 2 columns',
  config: {
    templateLayoutData: twoColumnsTextOnlyLayout,//json config
    templateStylingData: twoColumnsTextOnlyStylingData, //json config
    templateRenderData: twoColumnsTextOnlyRenderData,//json config    
  },
  category: ["all","text"],
  thumbnail: "/img.png",
  metadata: {},
};

//This is an example of gride-areas working
const twoV2ColumnsTextOnlyLayout = {
  node: 'section',
  areaId: 'section',
  ariaAttrs:[],
  classList:[],
  layoutDisplay:'grid',
  layoutStyles:[
    {attr:'display', value:'grid'}, 
    {attr:'gap', value:'1rem'}, 
    {attr:'grid-template-columns', value:'repeat(8, 1fr)'}, 
    {attr:'grid-template-areas', value:'"a a a a b b b b" "c c c c d d d d"'}, 
    {attr:'height', value:'auto!important'},
    {attr:'margin', value:'auto'},
  ],
  maxWidth: '682px',
  areas:[
    {
      node:'div',
      areaId:'td1',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-area', value:'a'},
      ],
      areas:[],
    },
    {
      node:'div',
      areaId:'td2',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-area', value:'b'},
      ],
      areas:[],
    },
    {
      node:'div',
      areaId:'td3',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-area', value:'c'},
        {attr:'padding', value:'20px'},        
      ],
      areas:[],
    },
    {
      node:'div',
      areaId:'td4',
      ariaAttrs:[],
      classList:[],
      layoutDisplay:'flex',
      layoutStyles:[
        {attr:'grid-area', value:'d'},
        {attr:'padding', value:'20px'},        
      ],
      areas:[],
    },
  ],
};

const twoColumnsV2TextOnlyStylingData = {
  section:[],
  td1:[{attr:'background', value:'#eeeeee'}],
  td2:[{attr:'background', value:'#eeeeee'}],
  td3:[{attr:'border', value:'1px solid #cccccc'}],
  td4: [{attr:'border', value:'1px solid #cccccc'}],
};

export const twoColumnsV2TextOnly = {
  id: "textTemplate2",
  type: "section",
  pluginId: "b8e2bb81-e603-11ec-9344-a7f4dfb24b7b",
  name: 'Text in 2 columns - Grid Areas',
  description: 'Text in 2 columns',
  config: {
    templateLayoutData: twoV2ColumnsTextOnlyLayout,//json config
    templateStylingData: twoColumnsV2TextOnlyStylingData, //json config
    templateRenderData: twoColumnsTextOnlyRenderData,//json config    
  },
  category: ["all","text"],
  thumbnail: "/img.png",
  metadata: {},
};